var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-input',{attrs:{"id":_vm.id,"value":_vm.inputValue},on:{"change":function($event){_vm.inputValue = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }